// extracted by mini-css-extract-plugin
module.exports = {"container":"Products-module--container--1R6aK"};